import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

import { cn } from '@/utils/tailwind';

export function ErrorBanner(props: {
  children: React.ReactNode;
  noIcon?: boolean;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'mb-6 rounded-xl bg-ls-red-400 px-5 py-4',
        !props.noIcon && 'pl-8',
        props.className
      )}
    >
      <div className="flex items-center gap-6">
        {!props.noIcon && (
          <div className="relative h-5 w-5 rounded-[20px]">
            <div className="absolute left-0 top-0 h-5 w-5" />
            <ExclamationTriangleIcon className="absolute left-0 top-0 h-5 w-5 stroke-white" />
          </div>
        )}
        {props.children}
      </div>
    </div>
  );
}
